import { keepPreviousData } from "@tanstack/react-query";
import { $api } from "../generated/client";

/**
 * Every shop matching `search`, for a super admin's shop switcher (BAB-3035).
 * Disabled for anyone else: the route is behind SuperAdminGuard.
 */
export function useSuperAdminShopSearch(search: string, isEnabled: boolean) {
  return $api.useQuery(
    "get",
    "/super-admin/shops/search",
    { params: { query: { q: search, limit: 20 } } },
    {
      // Nothing listed before a search: the first shops by name mean nothing.
      enabled: isEnabled && search.trim() !== "",
      placeholderData: keepPreviousData,
      staleTime: 30_000,
    },
  );
}
